<template>
  <div class="locale-changer">
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        <span :class="`iti-flag ${currentFlag}`"></span>
        {{ currentLanguage }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(lang, i) in get_locale_lang"
          :key="`Lang${i}`"
          :command="lang['id']"
        >
          <span :class="`iti-flag ${lang['country_code']}`"></span>
          {{ lang["label"] }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { loadLanguageAsync, i18n } from "@/plugins/i18n";
import { path, pathOr, find, propEq, propOr, compose } from "ramda";
import { locale_lang } from "@/helpers/languages";
export default {
  name: "locale-changer",
  computed: {
    get_locale_lang() {
      return locale_lang;
    },
    currentLanguage() {
      return compose(
        propOr("English", ["label"]),
        find(propEq("id", i18n.locale))
      )(this.get_locale_lang);
    },
    currentFlag() {
      return (
        compose(
          propOr("us", ["country_code"]),
          find(propEq("id", i18n.locale))
        )(this.get_locale_lang) || "us"
      );
    },
  },
  methods: {
    handleCommand(command) {
      loadLanguageAsync(command);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../scss/_flags.scss";
.el-dropdown {
  font-size: 16px;
}
.iti-flag {
  display: inline-block;
  margin-right: 8px;
}
.locale-changer {
  border: 1px solid #E6E6E6;
  box-sizing: border-box;
  border-radius: 123px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 20px;
}
.el-dropdown-menu {
  min-width: 150px;
}
</style>
